import {WordFix} from '../form-features/labels/WordFix';

export const containerSuffix = (suffix) => {
    if (suffix)
        return `
    > div {
        display: flex;
        align-items:center;
        ${WordFix}{
            border-radius:  0 var(--form-input-radius) var(--form-input-radius) 0;
        }
    }
    `;
    else
        return `
       
        `;
};

export const innerContainerSuffix = (suffix) => {
    if (!suffix) return ``;
    else
        return `
            border-right: none;
            border-radius:  var(--form-input-radius) 0 0 var(--form-input-radius);
        `;
};
